"use client";
import React, { useState } from "react";
import cx from "classnames";
import Image from "next/image";
import "./Common.css";

export const HäufigeFragen = ({
  fragen,
  image,
  title,
  changeOrder,
  removePaddingTop = false,
  removePaddingBottom = false,
  hideImage = false,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="FAQ"
      style={{
        paddingTop: removePaddingTop ? "0px" : "120px",
        paddingBottom: removePaddingBottom ? "0px" : "120px",
      }}
    >
      <div className="FAQ-wrapper">
        {changeOrder ? (
          <>
            {/* Render questions first */}
            <div
              className={`${
                hideImage
                  ? "FAQ-width-wrapper FAQ-Questions-wrapper"
                  : "FAQ-Questions-wrapper"
              }`}
            >
              <h2 className="section-title">{title}</h2>
              {fragen.map((item, index) => (
                <div
                  className="accordion__item details"
                  key={index}
                  onClick={() => toggleFAQ(index)}
                >
                  <header className="item__header">
                    <h3
                      className={cx(
                        "item__question transition",
                        openIndex === index ? "open" : ""
                      )}
                    >
                      {item.question}
                    </h3>
                    <div
                      className={`icon ${openIndex === index ? "open" : ""}`}
                    >
                      <span></span>
                      <span></span>
                    </div>
                  </header>
                  <div
                    className={`item__content ${
                      openIndex === index ? "open" : ""
                    }`}
                  >
                    <div className="item__answer">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
            {!hideImage && (
              <div className="FAQ-wrapper-left">
                <Image
                  src={image}
                  alt="Autoeinfachlos - Auto einfach online verkaufen"
                  width={500}
                  height={500}
                  sizes="(max-width: 1100px) calc(100vw - 48px), 500px"
                />
              </div>
            )}
          </>
        ) : (
          <>
            {!hideImage && (
              <div className="FAQ-wrapper-left ">
                <Image
                  src={image}
                  alt="Autoeinfachlos - Auto einfach online verkaufen"
                  width={500}
                  height={500}
                  sizes="(max-width: 1100px) calc(100vw - 48px), 500px"
                />
              </div>
            )}
            <div
              className={`${
                hideImage
                  ? "FAQ-width-wrapper FAQ-Questions-wrapper"
                  : "FAQ-Questions-wrapper"
              }`}
            >
              <h2>{title}</h2>
              {fragen.map((item, index) => (
                <div
                  className="accordion__item details"
                  key={index}
                  onClick={() => toggleFAQ(index)}
                >
                  <header className="item__header">
                    <h3
                      className={cx(
                        "item__question transition",
                        openIndex === index ? "open" : ""
                      )}
                    >
                      {item.question}
                    </h3>
                    <div
                      className={`icon ${openIndex === index ? "open" : ""}`}
                    >
                      <span></span>
                      <span></span>
                    </div>
                  </header>
                  <div
                    className={`item__content ${
                      openIndex === index ? "open" : ""
                    }`}
                  >
                    <div className="item__answer">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
